// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"1a9ff284","613":"3305e658"}[chunkId] + ".1793793499150.chunk.css";
};